// extracted by mini-css-extract-plugin
export default {"drawerHandle":"Burger_drawerHandle__HD9fi","drawerHandleIcon":"Burger_drawerHandleIcon__okOOT","drawerOpen":"Burger_drawerOpen__wTj4D"};